<template>
    <div
    class="jobDescriptionWrapper"
    >
        <p 
            v-if="companySpecificConfig.header == true"
            v-html="this.results.header"
        ></p>
        <p 
            class="jobDescriptionArea"
            v-html="this.results.desc"
        ></p>
        <p 
            v-if="companySpecificConfig.footer == true"
            v-html="this.results.footer"
        ></p>

    </div>
</template>
<script>
export default {

computed: {
  results() { return this.$store.state.results; },

companySpecificConfig: {
      get() { return this.$store.state.companySpecificConfig }
      },    
      }
}
</script>

<style>
    .jobDescriptionArea p {
        margin: 0px !important
    }
</style>